import React from "react";

import { ReactComponent as Cle } from "./icons8-clé.svg"; // Import SVG as React component
import { ReactComponent as CodeFile } from "./icons8-code-file.svg"; // Import SVG as React component
import { ReactComponent as CompteMarchand } from "./icons8-compte-marchand.svg"; // Import SVG as React component
import { ReactComponent as Content } from "./icons8-content.svg"; // Import SVG as React component
import { ReactComponent as CurseurMain } from "./icons8-curseur-main.svg"; // Import SVG as React component
import { ReactComponent as Curseur } from "./icons8-curseur.svg"; // Import SVG as React component
import { ReactComponent as Smartphone } from "./icons8-iphone-x.svg"; // Import SVG as React component
import { ReactComponent as DeuxSmartphone } from "./icons8-deux-smartphones.svg"; // Import SVG as React component
import { ReactComponent as Done } from "./icons8-done-50.svg"; // Import SVG as React component
import { ReactComponent as Download } from "./icons8-download-50.svg"; // Import SVG as React component
import { ReactComponent as Effacer } from "./icons8-effacer.svg"; // Import SVG as React component
import { ReactComponent as FormList } from "./icons8-liste (1).svg"; // Import SVG as React component
import { ReactComponent as Effacer2 } from "./icons8-effacer2.svg"; // Import SVG as React component
import { ReactComponent as Email } from "./icons8-email.svg"; // Import SVG as React component
import { ReactComponent as Inbox } from "./icons8-boîte-de-réception (1).svg"; // Import SVG as React component
import { ReactComponent as ErreurOrdinateur } from "./icons8-erreur-d&#39;ordinateur-portable.svg"; // Import SVG as React component
import { ReactComponent as Erreur } from "./icons8-erreur.svg"; // Import SVG as React component
import { ReactComponent as Admin } from "./icons8-expert.svg"; // Import SVG as React component
import { ReactComponent as Expert } from "./icons8-ingénieur.svg"; // Import SVG as React component

import { ReactComponent as Hexagone } from "./HexagoneFav451_black.svg"; // Import SVG as React component
import { ReactComponent as Hexagone2 } from "./HexaGoneFull.svg"; // Import SVG as React component
import { ReactComponent as Home } from "./icons8-home-50.svg"; // Import SVG as React component
import { ReactComponent as Message } from "./icons8-speech-bubble-50.svg"; // Import SVG as React component
import { ReactComponent as Folder } from "./icons8-folder-50.svg"; // Import SVG as React component
import { ReactComponent as Facture } from "./icons8-facture.svg"; // Import SVG as React component
import { ReactComponent as User } from "./icons8-utilisateur (1).svg"; // Import SVG as React component
import { ReactComponent as Client } from "./icons8-client.svg"; // Import SVG as React component

import { ReactComponent as Intervenant } from "./icons8-expert.svg"; // Import SVG as React component
import { ReactComponent as Settings } from "./icons8-settings-50.svg"; // Import SVG as React component
import { ReactComponent as SettingsFilled } from "./icons8-settings.svg"; // Import SVG as React component

import { ReactComponent as Devis } from "./icons8-ordre-d'achat (2).svg"; // Import SVG as React component
import { ReactComponent as Tag } from "./icons8-étiquette-de-prix (2).svg"; // Import SVG as React component
import { ReactComponent as Filtre } from "./icons8-filtre (2).svg"; // Import SVG as React component
import { ReactComponent as Integration } from "./icons8-puzzle.svg"; // Import SVG as React component
import { ReactComponent as Boutique } from "./icons8-compte-marchand.svg"; // Import SVG as React component
import { ReactComponent as Facturation } from "./icons8-carte-bancaire-dollar.svg"; // Import SVG as React component
import { ReactComponent as Logout } from "./icons8-logout-50.svg"; // Import SVG as React component
import { ReactComponent as Question } from "./icons8-question.svg"; // Import SVG as React component
import { ReactComponent as FullScreen } from "./icons8-plein-écran.svg"; // Import SVG as React component
import { ReactComponent as Heure } from "./icons8-heure-de-livraison.svg"; // Import SVG as React component
import { ReactComponent as Horloge } from "./icons8-horloge.svg"; // Import SVG as React component
import { ReactComponent as Cloche } from "./icons8-rappels-de-rendez-vous.svg"; // Import SVG as React component
import { ReactComponent as Logs } from "./icons8-liste-des-transactions.svg"; // Import SVG as React component
import { ReactComponent as Search } from "./icons8-chercher.svg"; // Import SVG as React component
import { ReactComponent as Close } from "./icons8-effacer.svg"; // Import SVG as React component
import { ReactComponent as Right } from "./icons8-vers-l'avant.svg"; // Import SVG as React component
import { ReactComponent as Left } from "./icons8-arrière.svg"; // Import SVG as React component
import { ReactComponent as Menu } from "./icons8-menu.svg"; // Import SVG as React component
import { ReactComponent as Modify } from "./icons8-modifier.svg"; // Import SVG as React component
import { ReactComponent as Delete } from "./icons8-trash-can-50.svg"; // Import SVG as React component
import { ReactComponent as Plus } from "./icons8-plus (3).svg"; // Import SVG as React component
import { ReactComponent as Minus } from "./icons8-moins (1).svg"; // Import SVG as React component
import { ReactComponent as Planning } from "./icons8-calendrier.svg"; // Import SVG as React component
import { ReactComponent as PDF } from "./icons8-pdf.svg"; // Import SVG as React component
import { ReactComponent as Join } from "./icons8-trombone.svg"; // Import SVG as React component
import { ReactComponent as Restauration } from "./icons8-restauration.svg"; // Import SVG as React component
import { ReactComponent as Rapport } from "./icons8-test-results-50.svg"; // Import SVG as React component
import { ReactComponent as Share } from "./icons8-transférer.svg"; // Import SVG as React component
import { ReactComponent as Share2 } from "./icons8-partager.svg"; // Import SVG as React component
import { ReactComponent as Archive } from "./icons8-classeur.svg"; // Import SVG as React component
import { ReactComponent as Date } from "./icons8-calendrier-12.svg"; // Import SVG as React component
import { ReactComponent as Organisation } from "./icons8-organisation.svg"; // Import SVG as React component
import { ReactComponent as Pinceau } from "./icons8-pinceau.svg"; // Import SVG as React component
import { ReactComponent as DeuxSmartphones } from "./icons8-deux-smartphones.svg"; // Import SVG as React component
import { ReactComponent as TestResults } from "./icons8-test-results-50.svg"; // Import SVG as React component
import { ReactComponent as NouveauMessage } from "./icons8-nouveau-message.svg"; // Import SVG as React component
import { ReactComponent as Sign } from "./icons8-main-avec-stylo.svg"; // Import SVG as React component
import { ReactComponent as Send } from "./icons8-envoyé.svg"; // Import SVG as React component
import { ReactComponent as Image } from "./icons8-image.svg"; // Import SVG as React component
import { ReactComponent as Youtube } from "./icons8-youtube.svg"; // Import SVG as React component
import { ReactComponent as Education } from "./icons8-chapeau-de-diplôme.svg"; // Import SVG as React component
import { ReactComponent as Lock } from "./icons8-lock-50.svg"; // Import SVG as React component
import { ReactComponent as Down } from "./icons8-flèche-développer.svg"; // Import SVG as React component
import { ReactComponent as Down2 } from "./icons8-sort-down.svg"; // Import SVG as React component
import { ReactComponent as Up2 } from "./icons8-sort-up.svg"; // Import SVG as React component

import { ReactComponent as Up } from "./icons8-flèche-réduire.svg"; // Import SVG as React component
import { ReactComponent as Tampon } from "./icons8-tampon-encreur.svg"; // Import SVG as React component
import { ReactComponent as Warning } from "./icons8-attention.svg"; // Import SVG as React component
import { ReactComponent as Param } from "./icons8-paramètres (1).svg"; // Import SVG as React component
import { ReactComponent as Done2 } from "./icons8-ok.svg"; // Import SVG as React component
import { ReactComponent as Done3 } from "./icons8-badge-vérifié.svg"; // Import SVG as React component
import { ReactComponent as Done4 } from "./icons8-verified-badge.svg"; // Import SVG as React component
import { ReactComponent as Mean } from "./icons8-calculatrice.svg"; // Import SVG as React component
import { ReactComponent as Taux } from "./icons8-pourcentage.svg"; // Import SVG as React component
import { ReactComponent as Restart } from "./icons8-redémarrer.svg"; // Import SVG as React component
import { ReactComponent as Late } from "./icons8-présent.svg"; // Import SVG as React component
import { ReactComponent as Text } from "./icons8-texte.svg"; // Import SVG as React component
import { ReactComponent as Response } from "./icons8-flèche-répondre-à-tous.svg"; // Import SVG as React component
import { ReactComponent as Cloud } from "./icons8-nuage-droit.svg"; // Import SVG as React component
import { ReactComponent as File } from "./icons8-document.svg"; // Import SVG as React component
import { ReactComponent as Photo } from "./icons8-unsplash.svg"; // Import SVG as React component
import { ReactComponent as Copy } from "./icons8-copie.svg"; // Import SVG as React component
import { ReactComponent as RTB2 } from "./icons8-lire-le-rapport-de-diagramme-circulaire.svg"; // Import SVG as React component
import { ReactComponent as Unlock } from "./icons8-ouvrir.svg"; // Import SVG as React component
import { ReactComponent as Products } from "./icons8-paramètre-de-magasin.svg"; // Import SVG as React component
import { ReactComponent as Xml } from "./icons8-xml.svg"; // Import SVG as React component
import { ReactComponent as Chauffage } from "./icons8-chauffage-de-pièce.svg"; // Import SVG as React component
import { ReactComponent as PlusEgal } from "./icons8-plus-ou-égal.svg"; // Import SVG as React component
import { ReactComponent as MoinsEgal } from "./icons8-moins-ou-égal.svg"; // Import SVG as React component
import { ReactComponent as Convert } from "./icons8-convertir.svg"; // Import SVG as React component
import { ReactComponent as RTB } from "./icons8-robot.svg"; // Import SVG as React component
import { ReactComponent as Phone } from "./icons8-téléphone.svg"; // Import SVG as React component
import { ReactComponent as Eye } from "./icons8-visible.svg"; // Import SVG as React component
import { ReactComponent as Invisible } from "./icons8-invisible.svg"; // Import SVG as React component

import { ReactComponent as Bad } from "./icons8-pouces-vers-le-bas.svg"; // Import SVG as React component

import { ReactComponent as Assistant } from "./icons8-assistant.svg"; // Import SVG as React component
import { ReactComponent as Tool } from "./icons8-couteau-suisse.svg"; // Import SVG as React component
import { ReactComponent as Hand } from "./icons8-poing-serré.svg"; // Import SVG as React component
import { ReactComponent as Administratif } from "./icons8-pile-de-papier.svg"; // Import SVG as React component
import { ReactComponent as NoWeb } from "./icons8-pas-de-web.svg"; // Import SVG as React component
import { ReactComponent as Automatic } from "./icons8-automatique.svg"; // Import SVG as React component

import { ReactComponent as Good } from "./icons8-pouce-en-l'air.svg"; // Import SVG as React component
import { ReactComponent as Secure } from "./icons8-sécurité-vérifiée.svg"; // Import SVG as React component
import { ReactComponent as Storage } from "./icons8-stockage.svg"; // Import SVG as React component
import { ReactComponent as ESign } from "./icons8-signature-numérique.svg"; // Import SVG as React component

import { ReactComponent as Control } from "./icons8-graphique-de-la-santé.svg"; // Import SVG as React component
import { ReactComponent as Position } from "./icons8-marqueur.svg"; // Import SVG as React component
import { ReactComponent as Stats } from "./icons8-graphique-combiné.svg"; // Import SVG as React component
import { ReactComponent as Plane } from "./icons8-hors-ligne.svg"; // Import SVG as React component
import { ReactComponent as Document } from "./icons8-document.svg"; // Import SVG as React component
import { ReactComponent as MobileMenu } from "./icons8-menu (1).svg"; // Import SVG as React component
import { ReactComponent as Collaboration } from "./icons8-collaboration.svg"; // Import SVG as React component
import { ReactComponent as Forum } from "./icons8-forum.svg"; // Import SVG as React component
import { ReactComponent as Forbidden } from "./icons8-annuler-2.svg"; // Import SVG as React component
import { ReactComponent as Equal } from "./icons8-signe-égal.svg"; // Import SVG as React component
import { ReactComponent as Invite } from "./icons8-invitation.svg"; // Import SVG as React component
import { ReactComponent as Payments } from "./icons8-machine-à-facturer.svg"; // Import SVG as React component
import { ReactComponent as LinkedFile } from "./icons8-fichier-lié.svg"; // Import SVG as React component
import { ReactComponent as CheckedDocFill } from "./icons8-check-document.svg"; // Import SVG as React component
import { ReactComponent as CheckedDoc } from "./icons8-check-document (1).svg"; // Import SVG as React component
import { ReactComponent as Car } from "./icons8-berline.svg"; // Import SVG as React component
import { ReactComponent as Position2 } from "./icons8-adresse.svg"; // Import SVG as React component
import { ReactComponent as Pizza } from "./icons8-pizza.svg"; // Import SVG as React component
import { ReactComponent as Transactions } from "./icons8-données-dans-les-deux-directions.svg"; // Import SVG as React component
import { ReactComponent as Back } from "./icons8-flèche-gauche.svg"; // Import SVG as React component
import { ReactComponent as Stars } from "./icons8-pétillant (1).svg"; // Import SVG as React component
import { ReactComponent as Star } from "./icons8-étoile.svg"; // Import SVG as React component
import { ReactComponent as Trello } from "./icons8-semaine-de-la-chronologie.svg"; // Import SVG as React component
import { ReactComponent as MobileCotrol } from "./icons8-installation-de-phonelink.svg"; // Import SVG as React component
import { ReactComponent as Pack } from "./icons8-paramètres-du-dossier.svg"; // Import SVG as React component
import { ReactComponent as AI } from "./icons8-ai.svg"; // Import SVG as React component
import { ReactComponent as Pin } from "./icons8-épingle.svg"; // Import SVG as React component
import { ReactComponent as UnPin } from "./icons8-détacher.svg"; // Import SVG as React component
import { ReactComponent as Cursor } from "./icons8-curseur-setup.svg"; // Import SVG as React component
import { ReactComponent as Pennylane } from "./pennylane.svg"; // Import SVG as React component
import { ReactComponent as GoodFilled } from "./icons8-thumbs-up.svg"; // Import SVG as React component
import { ReactComponent as BadFilled } from "./icons8-thumbs-down.svg"; // Import SVG as React component
import { ReactComponent as Rocket } from "./icons8-fusée (1).svg"; // Import SVG as React component
import { ReactComponent as Infiltrometre } from "./icons8-homme-populaire.svg"; // Import SVG as React component
import { ReactComponent as Stripe } from "./icons8-stripe (1).svg"; // Import SVG as React component
import { ReactComponent as Bridge } from "./bridge_logo.svg";
import { ReactComponent as Bookshelf } from "./icons8-bibliothèque.svg"; // Import SVG as React component
import { ReactComponent as OBBC } from "./icons8-triangle.svg"; // Import SVG as React component
import { ReactComponent as Desktop } from "./icons8-imac (1).svg"; // Import SVG as React component
import { ReactComponent as Infini } from "./icons8-infini.svg"; // Import SVG as React component
import { ReactComponent as Resize } from "./icons8-redimensionner-en-diagonal.svg"; // Import SVG as React component
import { ReactComponent as ATHIcon } from "./icons8-signer-un-document.svg"; // Import SVG as React component
import { ReactComponent as ATHSPEIcon } from "./icons8-signer-un-document (2).svg"; // Import SVG as React component
import { ReactComponent as DoubleLeft } from "./icons8-double-gauche.svg"; // Import SVG as React component
import { ReactComponent as DoubleRight } from "./icons8-double-droite.svg"; // Import SVG as React component
import { ReactComponent as Iframe } from "./icons8-navigateur-internet.svg"; // Import SVG as React component
import { ReactComponent as HexagoneLogement } from "./hexagone/hexaogne-logement-ready.svg"; // Import SVG as React component
import { ReactComponent as HexagoneAudit } from "./hexagone/hexaogne-audit-ready.svg"; // Import SVG as React component
import { ReactComponent as HexagoneInfiltro } from "./hexagone/hexagone-infiltro-ready.svg"; // Import SVG as React component
import { ReactComponent as HexagoneThermo } from "./hexagone/hexagone-thermo-ready.svg"; // Import SVG as React component
import { ReactComponent as HexagoneBasique } from "./hexagone/hexagone-basique-ready.svg"; // Import SVG as React component
import { ReactComponent as HexagoneLight } from "./hexagone/hexagone-light-ready.svg"; // Import SVG as React component
import { ReactComponent as Workspace } from "./icons8-bureau-à-domicile.svg"; // Import SVG as React component
import { ReactComponent as Replace } from "./icons8-remplacer.svg"; // Import SVG as React component
import { ReactComponent as Flag } from "./icons8-drapeau-2.svg"; // Import SVG as React component
import { ReactComponent as Link } from "./icons8-lien.svg"; // Import SVG as React component
import { ReactComponent as FileError } from "./icons8-document (1).svg"; // Import SVG as React component
import { ReactComponent as FileSuccess } from "./icons8-document (2).svg"; // Import SVG as React component
import { ReactComponent as Task } from "./icons8-a-faire.svg"; // Import SVG as React component
import { ReactComponent as Paste } from "./icons8-coller.svg"; // Import SVG as React component
import { ReactComponent as Filters } from "./icons8-réglages-horizontal.svg"; // Import SVG as React component

import { ReactComponent as Room } from "./icons8-chambre.svg"; // Import SVG as React component
import { ReactComponent as Appareil } from "./icons8-anémomètre.svg"; // Import SVG as React component
import { ReactComponent as Calibration } from "./icons8-vitesse (1).svg"; // Import SVG as React component
import { ReactComponent as System } from "./icons8-climatisation (1).svg"; // Import SVG as React component
import { ReactComponent as Batiment } from "./icons8-bâtiment (1).svg"; // Import SVG as React component
import { ReactComponent as Ensemble } from "./icons8-bâtiments-de-la-ville (1).svg"; // Import SVG as React component
import { ReactComponent as Bath } from "./icons8-douche-et-baignoire (1).svg"; // Import SVG as React component
import { ReactComponent as WC } from "./icons8-cuvette-des-toilettes (1).svg"; // Import SVG as React component
import { ReactComponent as NonConforme } from "./icons8-annuler (1).svg"; // Import SVG as React component
import { ReactComponent as Conforme } from "./icons8-ok (1).svg"; // Import SVG as React component
import { ReactComponent as Inconnu } from "./icons8-aide.svg"; // Import SVG as React component
import { ReactComponent as Caisson } from "./icons8-qualité-de-l'air (1).svg"; // Import SVG as React component
import { ReactComponent as Guide } from "./icons8-guide.svg"; // Import SVG as React component
import { ReactComponent as Escalier } from "./icons8-escalier.svg"; // Import SVG as React component
import { ReactComponent as SimpleFlux } from "./icons8-avance.svg"; // Import SVG as React component
import { ReactComponent as DoubleFlux } from "./icons8-flèches-tri-horizontal.svg"; // Import SVG as React component
import { ReactComponent as Individuelle } from "./icons8-arrêter-encadré.svg"; // Import SVG as React component
import { ReactComponent as Mutualisee } from "./icons8-diffusion.svg"; // Import SVG as React component
import { ReactComponent as Logement } from "./icons8-porte-ouverte.svg"; // Import SVG as React component
import { ReactComponent as Pression } from "./icons8-pression.svg"; // Import SVG as React component
import { ReactComponent as Debit } from "./icons8-élément-air (1).svg"; // Import SVG as React component
import { ReactComponent as Entree } from "./icons8-touche-entrée.svg"; // Import SVG as React component
import { ReactComponent as Cuisine } from "./icons8-frigo.svg"; // Import SVG as React component
import { ReactComponent as Table } from "./icons8-table.svg"; // Import SVG as React component
import { ReactComponent as Renovation } from "./icons8-rouleau-à-peinture.svg"; // Import SVG as React component
import { ReactComponent as Extension } from "./icons8-tous-dehors.svg"; // Import SVG as React component
import { ReactComponent as Plume } from "./icons8-rempli-en-plumes (1).svg"; // Import SVG as React component
import { ReactComponent as Gallery } from "./icons8-galerie.svg"; // Import SVG as React component
import { ReactComponent as Dashboard } from "./icons8-disposition-du-tableau-de-bord.svg"; // Import SVG as React component
import { ReactComponent as Project } from "./icons8-design.svg"; // Import SVG as React component
import { ReactComponent as Broadcast } from "./icons8-la-publicité.svg"; // Import SVG as React component
import { ReactComponent as Upload } from "./icons8-télécharger-vers-le-cloud (1).svg"; // Import SVG as React component
import { ReactComponent as Support } from "./icons8-support-en-ligne.svg"; // Import SVG as React component
import { ReactComponent as Business } from "./icons8-affaire.svg"; // Import SVG as React component
import { ReactComponent as Users } from "./icons8-conférence-téléphonique.svg"; // Import SVG as React component
import { ReactComponent as Cube } from "./icons8-cube (1).svg"; // Import SVG as React component
import { ReactComponent as Unlink } from "./icons8-lien-brisé.svg"; // Import SVG as React component
import { ReactComponent as Open } from "./icons8-lien-externe (1).svg"; // Import SVG as React component
import { ReactComponent as Sync } from "./icons8-synchroniser (1).svg"; // Import SVG as React component
import { ReactComponent as CarReception } from "./car-reception.svg";
import { ReactComponent as CarRestitution } from "./car-restitution.svg";
import { ReactComponent as SideAccueil } from "./sidebar-accueil.svg";
import { ReactComponent as SideReception } from "./sidebar-reception.svg";
import { ReactComponent as SideDossiers } from "./sidebar-dossiers.svg";
import { ReactComponent as SideAtelier } from "./sidebar-atelier.svg";
import { ReactComponent as SideVehicules } from "./sidebar-vehicules.svg";
import { ReactComponent as SideMessagerie } from "./sidebar-messagerie.svg";
import { ReactComponent as SideOrdres } from "./sidebar-ordres.svg";
import { ReactComponent as SideParametres } from "./sidebar-parametres.svg";
import { ReactComponent as SettDispo } from "./settings-dispo.svg";
import { ReactComponent as SettFast } from "./settings-fast.svg";
import { ReactComponent as SettRdv } from "./settings-rdv.svg";
import { ReactComponent as SettInterventions } from "./settings-interventions.svg";
import { ReactComponent as SettSign } from "./settings-sign.svg";
import { ReactComponent as SettPayments } from "./settings-payments.svg";
import { ReactComponent as SettServicebox } from "./settings-servicebox.svg";
import { ReactComponent as Tracking } from "./tracking.svg";
import { ReactComponent as Depot } from "./icons8-dépôt.svg";
import { ReactComponent as RecupArgent } from "./icons8-récupéré-l'argent.svg";
import { ReactComponent as ImportDevis } from "./import-devis.svg";

/**
 * @param {Object} props
 * @param {string} [props.name="clé"]
 * @param {string} [props.width="20px"]
 * @param {string} [props.height="20px"]
 * @param {number} [props.size=20]
 * @param {string} [props.color="black"]
 * @param {string} [props.margin="0px"]
 * @param {string} [props.padding="0px"]
 * @param {number} [props.strokeWidth=0] - Stroke width for SVG icons that support it.
 * @param {number} [props.rotation=0] - Rotation angle in degrees (e.g., 90, 180, 270).
  
 * @param {boolean} [props.animated=false] - If true, the hover effect applies when the parent element with 'group' class is hovered.
 */
function Icon1({
  name = "clé",
  size = 20,
  color = "black",
  margin = "0px",
  padding = "0px",
  strokeWidth = 0,
  animated = false,
  rotation = 0,
}) {
  const containerStyle = {
    width: `${size}px`,
    height: `${size}px`,
    margin,
    padding,
    display: "inline-block",
    transform: `rotate(${rotation}deg)`,
    transformOrigin: "center",
  };

  const svgStyle = {
    width: "100%",
    height: "100%",
    color: color,
    fill: color,
    stroke: color,
    strokeWidth: strokeWidth,
    transition: animated ? "all 0.3s ease" : undefined,
  };

  let html;
  // Changez style={svgStyle} en style={style}

  if (name === "photo") html = <Photo style={svgStyle} />;
  if (name === "file") html = <File style={svgStyle} />;
  if (name === "clé") html = <Cle style={svgStyle} />;
  if (name === "code-file") html = <CodeFile style={svgStyle} />;
  if (name === "compte-marchand") html = <CompteMarchand style={svgStyle} />;
  if (name === "content") html = <Content style={svgStyle} />;
  if (name === "curseur-main") html = <CurseurMain style={svgStyle} />;
  if (name === "curseur") html = <Curseur style={svgStyle} />;
  if (name === "deux-smartphones") html = <DeuxSmartphone style={svgStyle} />;
  if (name === "done") html = <Done style={svgStyle} />;
  if (name === "download") html = <Download style={svgStyle} />;
  if (name === "effacer") html = <Effacer style={svgStyle} />;
  if (name === "effacer2") html = <Effacer2 style={svgStyle} />;
  if (name === "form") html = <FormList style={svgStyle} />;

  if (name === "email") html = <Email style={svgStyle} />;
  if (name === "inbox") html = <Inbox style={svgStyle} />;
  if (name === "erreur-ordinateur")
    html = <ErreurOrdinateur style={svgStyle} />;
  if (name === "erreur") html = <Erreur style={svgStyle} />;
  if (name === "expert") html = <Expert style={svgStyle} />;
  if (name === "hexagone") html = <Hexagone style={svgStyle} />;
  if (name === "hexagone2") html = <Hexagone2 style={svgStyle} />;
  if (name === "home") html = <Home style={svgStyle} />;
  if (name === "message") html = <Message style={svgStyle} />;
  if (name === "folder") html = <Folder style={svgStyle} />;
  if (name === "facture") html = <Facture style={svgStyle} />;
  if (name === "client") html = <Client style={svgStyle} />;
  if (name === "intervenant") html = <Intervenant style={svgStyle} />;
  if (name === "settings") html = <Settings style={svgStyle} />;
  if (name === "settings-filled") html = <SettingsFilled style={svgStyle} />;

  if (name === "devis") html = <Devis style={svgStyle} />;
  if (name === "tag") html = <Tag style={svgStyle} />;
  if (name === "filtre") html = <Filtre style={svgStyle} />;
  if (name === "integration") html = <Integration style={svgStyle} />;
  if (name === "facturation") html = <Facturation style={svgStyle} />;
  if (name === "logout") html = <Logout style={svgStyle} />;
  if (name === "question") html = <Question style={svgStyle} />;
  if (name === "full-screen") html = <FullScreen style={svgStyle} />;
  if (name === "heure") html = <Heure style={svgStyle} />;
  if (name === "horloge") html = <Horloge style={svgStyle} />;
  if (name === "cloche") html = <Cloche style={svgStyle} />;
  if (name === "logs") html = <Logs style={svgStyle} />;
  if (name === "search") html = <Search style={svgStyle} />;
  if (name === "close") html = <Close style={svgStyle} />;
  if (name === "right") html = <Right style={svgStyle} />;
  if (name === "left") html = <Left style={svgStyle} />;
  if (name === "menu") html = <Menu style={svgStyle} />;
  if (name === "modify") html = <Modify style={svgStyle} />;
  if (name === "delete") html = <Delete style={svgStyle} />;
  if (name === "plus") html = <Plus style={svgStyle} />;
  if (name === "minus") html = <Minus style={svgStyle} />;
  if (name === "planning") html = <Planning style={svgStyle} />;
  if (name === "pdf") html = <PDF style={svgStyle} />;
  if (name === "join") html = <Join style={svgStyle} />;
  if (name === "restauration") html = <Restauration style={svgStyle} />;
  if (name === "rapport") html = <Rapport style={svgStyle} />;
  if (name === "share") html = <Share style={svgStyle} />;
  if (name === "share2") html = <Share2 style={svgStyle} />;
  if (name === "archive") html = <Archive style={svgStyle} />;
  if (name === "date") html = <Date style={svgStyle} />;
  if (name === "organisation") html = <Organisation style={svgStyle} />;
  if (name === "pinceau") html = <Pinceau style={svgStyle} />;
  if (name === "deux-smartphones") html = <DeuxSmartphones style={svgStyle} />;
  if (name === "test-results") html = <TestResults style={svgStyle} />;
  if (name === "nouveau-message") html = <NouveauMessage style={svgStyle} />;
  if (name === "sign") html = <Sign style={svgStyle} />;
  if (name === "send") html = <Send style={svgStyle} />;
  if (name === "image") html = <Image style={svgStyle} />;
  if (name === "smartphone") html = <Smartphone style={svgStyle} />;
  if (name === "youtube") html = <Youtube style={svgStyle} />;
  if (name === "education") html = <Education style={svgStyle} />;
  if (name === "lock") html = <Lock style={svgStyle} />;
  if (name === "down") html = <Down style={svgStyle} />;
  if (name === "down2") html = <Down2 style={svgStyle} />;

  if (name === "up") html = <Up style={svgStyle} />;
  if (name === "up2") html = <Up2 style={svgStyle} />;

  if (name === "tampon") html = <Tampon style={svgStyle} />;
  if (name === "warning") html = <Warning style={svgStyle} />;
  if (name === "param") html = <Param style={svgStyle} />;
  if (name === "done2") html = <Done2 style={svgStyle} />;
  if (name === "done3") html = <Done3 style={svgStyle} />;
  if (name === "done4") html = <Done4 style={svgStyle} />;
  if (name === "mean") html = <Mean style={svgStyle} />;
  if (name === "taux") html = <Taux style={svgStyle} />;
  if (name === "restart") html = <Restart style={svgStyle} />;
  if (name === "late") html = <Late style={svgStyle} />;
  if (name === "text") html = <Text style={svgStyle} />;
  if (name === "response") html = <Response style={svgStyle} />;
  if (name === "cloud") html = <Cloud style={svgStyle} />;
  if (name === "copy") html = <Copy style={svgStyle} />;
  if (name === "rtb") html = <RTB style={svgStyle} />;
  if (name === "unlock") html = <Unlock style={svgStyle} />;
  if (name === "products") html = <Products style={svgStyle} />;
  if (name === "xml") html = <Xml style={svgStyle} />;
  if (name === "chauffage") html = <Chauffage style={svgStyle} />;
  if (name === "plus-egal") html = <PlusEgal style={svgStyle} />;
  if (name === "moins-egal") html = <MoinsEgal style={svgStyle} />;
  if (name === "user") html = <User style={svgStyle} />;

  if (name === "convert") html = <Convert style={svgStyle} />;
  if (name === "admin") html = <Admin style={svgStyle} />;
  if (name === "phone") html = <Phone style={svgStyle} />;

  if (name === "eye") html = <Eye style={svgStyle} />;
  if (name === "bad") html = <Bad style={svgStyle} />;

  if (name === "assistant") html = <Assistant style={svgStyle} />;
  if (name === "tool") html = <Tool style={svgStyle} />;
  if (name === "hand") html = <Hand style={svgStyle} />;
  if (name === "administratif") html = <Administratif style={svgStyle} />;
  if (name === "no-web") html = <NoWeb style={svgStyle} />;
  if (name === "automatic") html = <Automatic style={svgStyle} />;
  if (name === "good") html = <Good style={svgStyle} />;
  if (name === "secure") html = <Secure style={svgStyle} />;
  if (name === "storage") html = <Storage style={svgStyle} />;
  if (name === "esign") html = <ESign style={svgStyle} />;

  if (name === "control") html = <Control style={svgStyle} />;
  if (name === "stats") html = <Stats style={svgStyle} />;
  if (name === "plane") html = <Plane style={svgStyle} />;
  if (name === "document") html = <Document style={svgStyle} />;
  if (name === "mobilemenu") html = <MobileMenu style={svgStyle} />;
  if (name === "collaboration") html = <Collaboration style={svgStyle} />;
  if (name === "invisible") html = <Invisible style={svgStyle} />;
  if (name === "forum") html = <Forum style={svgStyle} />;
  if (name === "forbidden") html = <Forbidden style={svgStyle} />;
  if (name === "equal") html = <Equal style={svgStyle} />;
  if (name === "invite") html = <Invite style={svgStyle} />;
  if (name === "payments") html = <Payments style={svgStyle} />;
  if (name === "linked_file") html = <LinkedFile style={svgStyle} />;
  if (name === "checked_doc") html = <CheckedDoc style={svgStyle} />;
  if (name === "checked_doc_fill") html = <CheckedDocFill style={svgStyle} />;
  if (name === "car") html = <Car style={svgStyle} />;
  if (name === "position") html = <Position style={svgStyle} />;
  if (name === "pizza") html = <Pizza style={svgStyle} />;
  if (name === "transactions") html = <Transactions style={svgStyle} />;
  if (name === "back") html = <Back style={svgStyle} />;
  if (name === "stars") html = <Stars style={svgStyle} />;
  if (name === "star") html = <Star style={svgStyle} />;
  if (name === "trello") html = <Trello style={svgStyle} />;
  if (name === "mobile-control") html = <MobileCotrol style={svgStyle} />;
  if (name === "pack") html = <Pack style={svgStyle} />;
  if (name === "ai") html = <AI style={svgStyle} />;
  if (name === "pin") html = <Pin style={svgStyle} />;
  if (name === "unpin") html = <UnPin style={svgStyle} />;
  if (name === "cursor") html = <Cursor style={svgStyle} />;
  if (name === "pennylane") html = <Pennylane style={svgStyle} />;
  if (name === "good-filled") html = <GoodFilled style={svgStyle} />;
  if (name === "bad-filled") html = <BadFilled style={svgStyle} />;
  if (name === "rocket") html = <Rocket style={svgStyle} />;
  if (name === "infiltrometre") html = <Infiltrometre style={svgStyle} />;
  if (name === "stripe") html = <Stripe style={svgStyle} />;
  if (name === "bookshelf") html = <Bookshelf style={svgStyle} />;
  if (name === "obbc") html = <OBBC style={svgStyle} />;
  if (name === "desktop") html = <Desktop style={svgStyle} />;
  if (name === "infini") html = <Infini style={svgStyle} />;
  if (name === "resize") html = <Resize style={svgStyle} />;
  if (name === "ath") html = <ATHIcon style={svgStyle} />;
  if (name === "athspe") html = <ATHSPEIcon style={svgStyle} />;
  if (name === "doubleleft") html = <DoubleLeft style={svgStyle} />;
  if (name === "doubleright") html = <DoubleRight style={svgStyle} />;
  if (name === "iframe") html = <Iframe style={svgStyle} />;
  if (name === "bridge") html = <Bridge style={svgStyle} />;

  if (name === "hexagone-logement")
    html = <HexagoneLogement style={svgStyle} />;
  if (name === "hexagone-audit") html = <HexagoneAudit style={svgStyle} />;
  if (name === "hexagone-infiltro")
    html = <HexagoneInfiltro style={svgStyle} />;
  if (name === "hexagone-thermo") html = <HexagoneThermo style={svgStyle} />;
  if (name === "hexagone-basique") html = <HexagoneBasique style={svgStyle} />;
  if (name === "hexagone-light") html = <HexagoneLight style={svgStyle} />;
  if (name === "workspace") html = <Workspace style={svgStyle} />;
  if (name === "replace") html = <Replace style={svgStyle} />;
  if (name === "flag") html = <Flag style={svgStyle} />;
  if (name === "link") html = <Link style={svgStyle} />;
  if (name === "file-error") html = <FileError style={svgStyle} />;
  if (name === "file-success") html = <FileSuccess style={svgStyle} />;
  if (name === "task") html = <Task style={svgStyle} />;
  if (name === "paste") html = <Paste style={svgStyle} />;
  if (name === "filters") html = <Filters style={svgStyle} />;

  if (name === "room") html = <Room style={svgStyle} />;
  if (name === "appareil") html = <Appareil style={svgStyle} />;
  if (name === "calibration") html = <Calibration style={svgStyle} />;
  if (name === "system") html = <System style={svgStyle} />;
  if (name === "logement") html = <Logement style={svgStyle} />;
  if (name === "batiment") html = <Batiment style={svgStyle} />;
  if (name === "bath") html = <Bath style={svgStyle} />;
  if (name === "wc") html = <WC style={svgStyle} />;
  if (name === "non_conforme") html = <NonConforme style={svgStyle} />;
  if (name === "conforme") html = <Conforme style={svgStyle} />;
  if (name === "inconnu") html = <Inconnu style={svgStyle} />;
  if (name === "caisson") html = <Caisson style={svgStyle} />;
  if (name === "guide") html = <Guide style={svgStyle} />;
  if (name === "escalier") html = <Escalier style={svgStyle} />;
  if (name === "simple-flux") html = <SimpleFlux style={svgStyle} />;
  if (name === "double-flux") html = <DoubleFlux style={svgStyle} />;
  if (name === "individuelle") html = <Individuelle style={svgStyle} />;
  if (name === "mutualisee") html = <Mutualisee style={svgStyle} />;
  if (name === "ensemble") html = <Ensemble style={svgStyle} />;
  if (name === "pression") html = <Pression style={svgStyle} />;
  if (name === "debit") html = <Debit style={svgStyle} />;
  if (name === "entree") html = <Entree style={svgStyle} />;
  if (name === "cuisine") html = <Cuisine style={svgStyle} />;
  if (name === "table") html = <Table style={svgStyle} />;
  if (name === "renovation") html = <Renovation style={svgStyle} />;
  if (name === "extension") html = <Extension style={svgStyle} />;
  if (name === "plume") html = <Plume style={svgStyle} />;
  if (name === "gallery") html = <Gallery style={svgStyle} />;
  if (name === "dashboard") html = <Dashboard style={svgStyle} />;
  if (name === "design") html = <Project style={svgStyle} />;
  if (name === "broadcast") html = <Broadcast style={svgStyle} />;
  if (name === "upload") html = <Upload style={svgStyle} />;
  if (name === "support") html = <Support style={svgStyle} />;
  if (name === "business") html = <Business style={svgStyle} />;
  if (name === "users") html = <Users style={svgStyle} />;
  if (name === "cube") html = <Cube style={svgStyle} />;
  if (name === "unlink") html = <Unlink style={svgStyle} />;
  if (name === "open") html = <Open style={svgStyle} />;

  if (name === "sync") html = <Sync style={svgStyle} />;

  // Custom car icons
  if (name === "car-reception") html = <CarReception style={svgStyle} />;
  if (name === "car-restitution") html = <CarRestitution style={svgStyle} />;

  // Sidebar icons (Figma)
  if (name === "side-accueil") html = <SideAccueil style={svgStyle} />;
  if (name === "side-reception") html = <SideReception style={svgStyle} />;
  if (name === "side-dossiers") html = <SideDossiers style={svgStyle} />;
  if (name === "side-atelier") html = <SideAtelier style={svgStyle} />;
  if (name === "side-ordres") html = <SideOrdres style={svgStyle} />;
  if (name === "side-vehicules") html = <SideVehicules style={svgStyle} />;
  if (name === "side-messagerie") html = <SideMessagerie style={svgStyle} />;
  if (name === "side-parametres") html = <SideParametres style={svgStyle} />;

  // Settings bar icons
  if (name === "sett-dispo") html = <SettDispo style={svgStyle} />;
  if (name === "sett-fast") html = <SettFast style={svgStyle} />;
  if (name === "sett-rdv") html = <SettRdv style={svgStyle} />;
  if (name === "sett-interventions") html = <SettInterventions style={svgStyle} />;
  if (name === "sett-sign") html = <SettSign style={svgStyle} />;
  if (name === "sett-payments") html = <SettPayments style={svgStyle} />;
  if (name === "sett-servicebox") html = <SettServicebox style={svgStyle} />;
  if (name === "tracking") html = <Tracking style={svgStyle} />;
  if (name === "depot") html = <Depot style={svgStyle} />;
  if (name === "recup-argent") html = <RecupArgent style={svgStyle} />;
  if (name === "import-devis") html = <ImportDevis style={svgStyle} />;

  return <div style={containerStyle}>{html}</div>;
}

export default Icon1;
